import { z } from "zod";

/**
 * RFC 9457 problem details — the one error shape every endpoint returns. `code` carries
 * the domain error identifier (`DomainError.code`) so clients branch on it, never on text.
 */
export const Problem = z.object({
  type: z.string().default("about:blank"),
  title: z.string(),
  status: z.number().int(),
  detail: z.string().optional(),
  /** Stable machine code: `validation`, `unauthenticated`, `forbidden`, `not_found`, or a DomainError code. */
  code: z.string(),
  /** Zod issues for `validation` problems. */
  errors: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
  requestId: z.string().optional(),
});
export type Problem = z.infer<typeof Problem>;

/** Common response sets so every contract declares the same failure shapes. */
export const PROBLEMS = {
  400: Problem,
  401: Problem,
  403: Problem,
  404: Problem,
  409: Problem,
  422: Problem,
} as const;
